<glxy-chat-message-group [showProfilePic]="false">
  <glxy-chat-message [isTyping]="loading">{{ rendered$ | async }}</glxy-chat-message>
</glxy-chat-message-group>
